import { Link } from "@inertiajs/react";
import classNames from "classnames";
import React from "react";
import { twMerge } from "tailwind-merge";
import RippleEffect from "./RippleEffect";

const PrimaryButton = ({
    as = 'button',
    href = '#',
    type = 'submit',
    processing,
    children,
    onClick,
    className = '',
    bgClass = '',
    isOutline = false,
    outlineClass = '',
    textClass = '',
    isRounded = false,
    roundedClass = '',
    isShadow = false,
    shadowClass = '',
    ...attrs
}) => {
    const classBtn = classNames(
        'px-4 py-2 lg:px-10 lg:py-4 leading-none font-semibold ripple text-nowrap text-center',
        {
            'text-white': !isOutline && textClass === '',
            'text-primary': isOutline && textClass === '',
            'text-sm leading-none': textClass === '',
            [textClass]: textClass !== '',
            'bg-primary hover:bg-primary/70': !isOutline && bgClass === '',
            'bg-white hover:bg-primary/10': isOutline && bgClass === '',
            [bgClass]: bgClass !== '',
            'border border-primary': isOutline && outlineClass === '',
            [outlineClass]: isOutline && outlineClass !== '',
            'rounded-full': isRounded && roundedClass === '',
            [roundedClass]: isRounded && roundedClass !== '',
            'shadow-lg': isShadow && shadowClass === '',
            [shadowClass]: isShadow && shadowClass !== '',
        },
        className,
    );

    return as === 'link' ? (
        <Link href={href} onClick={(e) => typeof onClick === 'function' && onClick(e)} className={twMerge(classBtn)} {...attrs}>
            {children}
            <RippleEffect />
        </Link>
    ) : (
        <button
            type={type}
            onClick={(e) => typeof onClick === 'function' && onClick(e)}
            className={twMerge(classBtn)}
            disabled={processing}
            {...attrs}
        >
            {children}
            <RippleEffect />
        </button>
    );
};

export default PrimaryButton;
